import { Controller } from '@hotwired/stimulus'

export default class RebrandingKycDocumentFormController extends Controller {
  static targets = [
    'backDocumentContainer',
    'addBackDocumentLabel',
    'removeBackDocumentLabel',
    'backFileInput',
    'containerDocument',
  ];

  toggleBackDocument() {
    this.backDocumentContainerTarget.classList.toggle('d-none');
    this.updateBackDocumentToggleVisibility();
    if (!this.isBackDocumentVisible()) {
      this.clearBackInput();
    }

    if(this.hasContainerDocumentTarget) {
      this.containerDocumentTarget.classList.toggle('row-cols-lg-2');
    }
  }

  clearBackInput() {
    if (this.backFileInputTarget?.value) {
      this.backFileInputTarget.value = '';
      this.backFileInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateBackDocumentToggleVisibility() {
    this.addBackDocumentLabelTarget.classList.toggle('d-none', this.isBackDocumentVisible())
    this.removeBackDocumentLabelTarget.classList.toggle('d-none', !this.isBackDocumentVisible())
  }

  isBackDocumentVisible() {
    return !this.backDocumentContainerTarget.classList.contains('d-none')
  }
}
